/**
 * Valid referrer URL patterns for showing the "Back to property" link on the lead management page.
 * Capture group 1 is the referring listing alias (see useReferringListingAlias).
 */
export const VALID_BACK_LINK_REFERRER_PATTERNS = [
  /^\/rental-manager\/properties\/([^/]+)\/dashboard\/overview\/?$/,
  /^\/rental-manager\/properties\/([^/]+)\/dashboard\/applications\/?$/,
];
